import { HttpContextToken } from '@angular/common/http';

/**
 * Cuando se establece en `true` en el contexto de una petición HTTP,
 * el `errorInterceptor` omite llamar a `ErrorService.showApiError()`
 * y delega el manejo del error al consumidor (componente o servicio).
 *
 * Uso:
 *   this.http.post(url, body, {
 *     context: new HttpContext().set(SKIP_ERROR_TOAST, true),
 *   });
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
